import { list } from './list';
import type { SportsBook } from '@/types/SportsBook';

interface SportsBookPathEntry extends Omit<SportsBook, 'slug'> {
  slug: string;
}

export function createSportsBookList<const T extends SportsBookPathEntry[]>(
  list: T,
): T {
  return list;
}

export const sportsBookList = list;

export type SportsBookSlugList = (typeof sportsBookList)[number]['slug'];
